<template>
  <div class="px-10 pt-4 creator-info container-center">
    <p
      class="text-h5 mb-10 font-weight-bold w100p"
      style="text-align: left; max-width: 903px"
    >
      <!-- 創作者資訊 -->
      {{ $t('SIDEBAR.ITEM.PERSONAL') }}
    </p>

    <v-card color="neutral800 w100p" max-width="903" class="b-rad-20">
      <v-card-text>
        <v-card-title>
          <SizeBox width="8" />
          {{ $t('ACCOUNT.WORD.BASICS') }}
          <v-spacer></v-spacer>
          <!-- <v-icon v-if="!isEdit" @click="openEdit">mdi-pencil</v-icon> -->
        </v-card-title>

        <v-row>
          <v-col cols="2" class="d-flex text-subtitle-1 pa-4">
            <SizeBox width="8" />
            {{ $t('ACCOUNT.WORD.PROFILE') }}
          </v-col>
          <v-col>
            <label>
              <v-hover #default="{ hover }">
                <v-avatar
                  size="72"
                  class="cursor-pointer"
                  :class="{ 'elevation-2': !avatar }"
                >
                  <v-img
                    :src="avatar || require(`@/assets/icons/avatar.svg`)"
                    class="fill-all"
                  >
                    <div v-show="hover" class="pos-a fill-all flex-center">
                      <div
                        class="neutral600 flex-center text-caption text-no-wrap"
                      >
                        <v-icon size="12" class="mr-1">mdi-camera</v-icon>
                        {{ $t('ACCOUNT.WORD.CHANGE_PROFILE') }}
                      </div>
                    </div>
                  </v-img>
                </v-avatar>
              </v-hover>
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                hidden
                @change="handleFileChange"
              />
            </label>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" style="padding-left: 25px">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" class="d-flex text-subtitle-1 pa-4">
            <SizeBox width="8" />
            {{ $t('ACCOUNT.WORD.NICKNAME') }}
          </v-col>
          <v-col class="d-flex align-center">
            <v-text-field
              v-model="nickname"
              :readonly="!nicknameIsEdit"
              :placeholder="
                $t('COMMON.WORD.PLEASE') + $t('AUTH.COPYWRITING.ENTER_NICKNAME')
              "
              class="no-shadow pl-0"
              :background-color="'transparent'"
              hide-details
              dense
              solo
              :class="{ inputIsEdit: nicknameIsEdit }"
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="d-flex justify-end">
            <v-btn
              text
              small
              @click="
                nicknameIsEdit = true;
                initData();
              "
              v-if="!nicknameIsEdit"
            >
              <v-icon color="" size="18" class="mr-1">mdi-pencil</v-icon>
              {{ $t('COMMON.WORD.EDIT') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" style="padding-left: 25px">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-expand-transition>
          <v-card
            v-if="nicknameIsEdit"
            color="neutral800"
            max-width="800"
            class="b-rad-20"
          >
            <v-card-text class="d-flex justify-end">
              <v-btn
                width="55"
                height="38"
                @click="cancleEdit"
                color="neutral500"
                style="width: auto"
              >
                {{ $t('COMMON.WORD.CANCEL') }}
              </v-btn>
              <SizeBox width="16" />
              <v-btn
                color="primary"
                width="55"
                height="38"
                @click="saveResult"
                :loading="isLoading"
                style="width: auto"
              >
                {{ $t('COMMON.WORD.SAVE_CHANGES') }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-expand-transition>
        <v-row class="major">
          <v-col cols="2" class="d-flex text-subtitle-1 pa-4">
            <SizeBox width="8" />
            {{ $t('ACCOUNT.WORD.PROFESSION') }}
          </v-col>
          <v-col class="pa-4" style="padding-top: 20px !important">
            <v-row v-if="majorEdit" class="edit">
              <v-col cols="12" class="text-12px pt-0">
                {{ $t('ACCOUNT.COPYWRITING.SELECT_TAGS_FOR_YOUR_PROFESSION') }}
                ( {{ displayMajorOptions.length }} / 3 )
              </v-col>
              <v-col>
                <v-btn
                  outlined
                  v-for="item in majorOptions"
                  :key="`major:${item.value}`"
                  class="mr-3 mb-3"
                  :color="item.checked ? 'primary' : 'neutral100'"
                  @click="pickMajor(item)"
                  col="12"
                >
                  <v-icon v-if="item.checked" size="18">mdi-check</v-icon>
                  {{ $t(item.textKey) }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="!majorEdit" class="display">
              <v-col class="pt-0 pl-0">
                <v-btn
                  outlined
                  v-for="item in displayMajorOptions"
                  :key="`major:${item.value}`"
                  class="mr-3 mb-3"
                  :color="'neutral100'"
                  @click="pickMajor(item)"
                  col="12"
                  disabled
                >
                  {{ $t(item.textKey) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" class="d-flex justify-end">
            <v-btn
              text
              small
              @click="
                majorEdit = true;
                initData();
              "
              v-if="!majorEdit"
            >
              <v-icon color="" size="18" class="mr-1">mdi-pencil</v-icon>
              {{ $t('COMMON.WORD.EDIT') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-expand-transition>
          <v-card
            v-if="majorEdit"
            color="neutral800"
            max-width="800"
            class="b-rad-20"
          >
            <v-card-text class="d-flex justify-end">
              <v-btn
                width="55"
                height="38"
                @click="cancleEdit"
                color="neutral500"
                style="width: auto"
              >
                {{ $t('COMMON.WORD.CANCEL') }}
              </v-btn>
              <SizeBox width="16" />
              <v-btn
                color="primary"
                width="55"
                height="38"
                @click="saveResult"
                :loading="isLoading"
                style="width: auto"
              >
                {{ $t('COMMON.WORD.SAVE_CHANGES') }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-expand-transition>
      </v-card-text>
    </v-card>

    <SizeBox height="48" />

    <v-card color="neutral800" max-width="903" class="b-rad-20 pb-8 w100p">
      <v-card-text>
        <v-card-title>
          <SizeBox width="8" />
          {{ $t('ACCOUNT.WORD.ABOUT_ME') }}
        </v-card-title>

        <v-row align="start">
          <v-col cols="2" class="d-flex text-subtitle-1 mt-1 pa-4">
            <SizeBox width="8" />

            {{ $t('COMMON.WORD.DESCRIPTION') }}
          </v-col>
          <v-col class="mt-1 pa-4">
            <div
              v-html="description"
              class="no-shadow description-wrapper"
              :background-color="descriptionIsEdit ? null : 'transparent'"
              v-show="!descriptionIsEdit && description != ''"
              style="color: #ffffff"
            ></div>
            <p
              v-show="description == ''"
              style="color: #929292; line-height: 1.75rem"
            >
              {{ $t('ACCOUNT.COPYWRITING.LET_OTHERS_KNOW_MORE_ABOUT_YOU') }}
            </p>
            <div
              class="editor"
              style="position: relative"
              v-show="descriptionIsEdit"
            >
              <VueEditor
                class="VueEditor"
                :class="{
                  _error: !!descriptionError,
                  _focus: descriptionFocus
                }"
                v-model="description"
                @focus="descriptionFocus = true"
                @blur="
                  detectDescription();
                  descriptionFocus = false;
                "
                @input="detectDescription"
                useCustomImageHandler
                @image-added="handleImageAdded"
                :editorToolbar="customToolbar"
              ></VueEditor>
              <v-btn
                class="tutorial_btn"
                :href="'https://hei-dong-chuang-zao.gitbook.io/virsody-guide/bian-ji-zhan-jian-zuo-pin/shang-chuan-xin-zeng-zuo-pin/zuo-pin-zi-xun-lan-wen-zi-bian-ji-qi-gong-neng'"
                :ripple="false"
                :target="'_blank'"
              >
                {{ $t('COMMON.WORD.TUTORIAL') }}
              </v-btn>
            </div>
            <v-card
              v-if="descriptionIsEdit"
              color="neutral800"
              max-width="800"
              class="b-rad-20"
            >
              <v-card-text class="d-flex justify-end">
                <v-btn
                  width="55"
                  height="38"
                  @click="cancleEdit"
                  color="neutral500"
                  style="width: auto"
                >
                  {{ $t('COMMON.WORD.CANCEL') }}
                </v-btn>
                <SizeBox width="16" />
                <v-btn
                  color="primary"
                  width="55"
                  height="38"
                  @click="saveResult"
                  :loading="isLoading"
                  style="width: auto"
                >
                  {{ $t('COMMON.WORD.SAVE_CHANGES') }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="1" class="d-flex justify-end">
            <v-btn
              text
              small
              @click="
                descriptionIsEdit = true;
                initData();
              "
              v-if="!descriptionIsEdit"
            >
              <v-icon color="" size="18" class="mr-1">mdi-pencil</v-icon>
              {{ $t('COMMON.WORD.EDIT') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <SizeBox height="48" />
    <v-dialog
      v-model="isShowClipper"
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card color="neutral700" class="b-rad-8">
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-avatar
            size="24"
            @click="isShowClipper = false"
            class="close_btn cursor-pointer"
          >
            <img :src="require(`@/assets/icons/close.svg`)" />
          </v-avatar>
        </div>
        <v-card-title class="flex-center text-h5">
          {{ $t('ACCOUNT.WORD.CHANGE_PROFILE') }}
        </v-card-title>

        <v-card-text class="text-center">
          {{ $t('ACCOUNT.COPYWRITING.DRAG_TO_CROP') }}
          <br />
          {{ $t('ACCOUNT.COPYWRITING.AND_RESIZE_YOUR_PHOTO') }}
        </v-card-text>

        <v-card-text>
          <clipper-basic
            ref="CLIPPER"
            bg-color="transparent"
            :src="imageDataUrl"
            :ratio="1"
            :area="90"
          />
        </v-card-text>

        <v-card-actions class="flex-center pb-6">
          <v-btn outlined @click="cancelClip" style="width: auto">
            {{ $t('COMMON.WORD.CANCEL') }}
          </v-btn>
          <v-btn
            color="primary"
            depressed
            @click="doClip"
            :loading="isUploadingAvatar"
            style="width: auto"
          >
            {{ $t('ARTWORK.EDIT.COPYWRITING.CROP') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { addImageByCategory } from '@/api/panel/images';
import { mapGetters } from 'vuex';
import { editTeam } from '@/api/panel';
import { VueEditor } from 'vue2-editor';
export default {
  components: { VueEditor },
  data() {
    return {
      isUploadingAvatar: false,
      isShowClipper: false,
      previewFile: null,
      previewImg: '',

      isLoading: false,
      isEdit: false,

      descriptionError: null,
      descriptionFocus: false,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link', 'image', 'video'],
        ['clean'] // remove formatting button
      ],
      nickname: '',
      nicknameIsEdit: false,
      majors: [],
      majorEdit: false,
      description: '',
      descriptionIsEdit: false,
      isMajorFetching: false,
      isMajorOpen: false,
      majorOptions: [
        {
          text: '藝術',
          value: 'art',
          checked: false,
          textKey: 'COMMON.WORD.ART'
        },
        {
          text: 'NFT',
          value: 'nft',
          checked: false,
          textKey: 'COMMON.WORD.NFT'
        },
        {
          text: '設計',
          value: 'design',
          checked: false,
          textKey: 'COMMON.WORD.DESIGN'
        },
        {
          text: '音樂',
          value: 'music',
          checked: false,
          textKey: 'COMMON.WORD.MUSIC'
        },
        {
          text: '攝影',
          value: 'photograph',
          checked: false,
          textKey: 'COMMON.WORD.PHOTOGRAPHY'
        },
        {
          text: '區塊鏈',
          value: 'blockChain',
          checked: false,
          textKey: 'COMMON.WORD.BLOCKCHAIN'
        },
        {
          text: '文學',
          value: 'literature',
          checked: false,
          textKey: 'COMMON.WORD.CULTURE'
        },
        {
          text: '商業',
          value: 'business',
          checked: false,
          textKey: 'COMMON.WORD.BUSINESS'
        },
        {
          text: '教育',
          value: 'education',
          checked: false,
          textKey: 'COMMON.WORD.EDUCATION'
        },
        {
          text: '公益',
          value: 'charity',
          checked: false,
          textKey: 'COMMON.WORD.CHARITY'
        }
      ],
      editorData: '<p>Content of the editor.</p>'
    };
  },

  computed: {
    ...mapGetters({
      Team: 'auth/getTeam',
      User: 'auth/getUser'
    }),
    imageDataUrl() {
      return this.previewFile ? URL.createObjectURL(this.previewFile) : '';
    },
    avatar() {
      return this.Team && this.Team.avatar && this.Team.avatar.url;
    },

    displayMajorOptions() {
      return this.majorOptions.filter(({ checked }) => checked);
    }
  },

  watch: {
    displayMajorOptions(v) {
      this.majors = v.map(({ text }) => text);
    }
  },

  mounted() {
    this.initData();
  },

  methods: {
    detectDescription() {
      this.descriptionError = this.description
        ? null
        : this.$t('ARTWORK.EDIT.INPUT.ALERT.PLEASE_ENTER_ITEM_INFO');
    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      if (file.size > 1048576 * 5) {
        this.$toast.error(
          this.$t('ARTWORK.EDIT.TOAST.ALERT.IMAGE_SIZE_CANNOT_EXCEED_5MB')
        );
        resetUploader();
        return;
      }
      const formData = new FormData();
      formData.append('file', file);

      const { url, error } = await addImageByCategory({
        category: 'other',
        data: formData
      });

      if (!error) {
        Editor.insertEmbed(cursorLocation, 'image', url);
        resetUploader();
      } else {
        this.$toast.error(error.message || '圖片上傳失敗');
      }
    },
    openClipper() {
      this.isShowClipper = true;
    },
    doClip() {
      const canvas = this.$refs.CLIPPER.clip({ maxWPixel: 512 });
      this.previewImg = canvas.toDataURL();

      canvas.toBlob((blob) => {
        this.uploadAvatar(blob);
      });
    },
    async uploadAvatar(file) {
      this.isUploadingAvatar = true;
      const formData = new FormData();
      formData.append('file', file);

      const Res = await addImageByCategory({
        category: 'avatar',
        data: formData
      });

      let isError = !!Res.error;

      if (!isError) {
        const { error } = await editTeam({
          nickname: this.Team.nickname,
          description: this.Team.description,
          tags: this.Team.tags.join(','),
          avatarId: Res.id
        });

        isError = !!error;

        if (!isError) {
          this.$store.dispatch('auth/CHECK_LOGIN_STATUS');
          this.isUploadingAvatar = false;
          this.isShowClipper = false;
          this.previewFile = null;
          this.previewImg = '';
          this.$toast(this.$t('ARTWORK.EDIT.TOAST.SUCCESS.UPLOAD_SUCCESSFUL'));
          await this.$store.dispatch('auth/FETCH_TEAMS');
          this.initData();
        }
      }

      if (isError)
        this.$toast.error(this.$t('ARTWORK.EDIT.TOAST.ALERT.UPLOAD_FAILED'));

      this.isUploadingAvatar = true;
    },
    cancelClip() {
      this.previewImg = null;
      this.previewFile = null;
      this.isShowClipper = false;
    },
    handleWheel(e) {
      if (this.previewedImageName) return;
      if (e.deltaY > 0 && this.workWidthPercent > 39) this.workWidthPercent--;
      if (e.deltaY < 0 && this.workWidthPercent < 100) this.workWidthPercent++;
    },
    handleFileChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.handlePreview(file);
      }
    },

    handlePreview(file) {
      if (file.size > 1048576 * 2) {
        this.$toast.error(
          `${this.$t('ARTWORK.EDIT.COPYWRITING.FILE_SIZE_NOT_EXCEED')} 2MB`
        );
        return;
      }

      this.previewFile = file;
      this.isShowClipper = true;
    },

    initData() {
      this.nickname = this.Team.nickname;
      this.majors = this?.Team?.tags || [];
      this.description = this.Team.description;

      this.majorOptions.forEach(
        (item) => this.majors.includes(item.text) && (item.checked = true)
      );
    },

    openEdit() {
      this.initData();
      this.isEdit = true;
    },
    cancleEdit() {
      this.initData();
      // this.isEdit = false;
      this.nicknameIsEdit = this.majorEdit = this.descriptionIsEdit = false;
    },
    async saveResult() {
      this.isLoading = true;
      const { error } = await editTeam({
        nickname: this.nickname,
        description: this.description,
        tags: this.majors.join(','),
        avatarId: this.Team.avatar ? this.Team.avatar.id : this.Team.avatar
      });

      if (!error) {
        this.$store.dispatch('auth/CHECK_LOGIN_STATUS');
        this.$toast(this.$t('COMMON.WORD.SAVED'));
        await this.$store.dispatch('auth/FETCH_TEAMS');
        this.initData();
        this.nicknameIsEdit = this.majorEdit = this.descriptionIsEdit = false;
      }
      this.isLoading = false;
    },

    async toggleMajorOptions() {
      if (this.isMajorOpen) {
        const { error } = await editTeam({
          nickname: this.nickname,
          description: this.description,
          tags: this.majors.join(','),
          avatarId: this.Team.avatar.id
        });

        if (!error) {
          this.$store.dispatch('auth/CHECK_LOGIN_STATUS');
          this.$toast(this.$t('COMMON.WORD.SAVED'));
        }
      }
      this.isMajorOpen = !this.isMajorOpen;
    },
    pickMajor(item) {
      if (this.displayMajorOptions.length >= 3 && !item.checked) return;
      item.checked = !item.checked;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .ql-snow .ql-picker {
    color: #c9c9c9;
  }
  .ql-snow .ql-picker.ql-header {
    width: 90px;
  }
  .quillWrapper .ql-picker-label {
    font-size: 12px;
  }
  .quillWrapper .ql-snow .ql-stroke {
    stroke: #c9c9c9;
  }
  .quillWrapper .ql-snow.ql-toolbar {
    border-radius: 10px 10px 0 0;
    background-color: #070707;
    border: none;
  }
  .ql-container.ql-snow {
    border: none;
    border-radius: 0 0 10px 10px;
    background-color: #232323;
  }
  .ql-snow .ql-toolbar button,
  .ql-snow.ql-toolbar button {
    padding: 4px 5px;
    width: 25px;
  }
  .ql-picker.ql-color-picker svg {
    width: 20px !important;
    height: 20px !important;
  }
  .ql-editor {
    min-height: 250px;
    max-height: 268px;
  }
  .quillWrapper .ql-toolbar.ql-snow .ql-formats {
    margin-right: 0px;
    margin-bottom: 6px;
  }
  .ql-snow .ql-toolbar button svg,
  .quillWrapper .ql-snow.ql-toolbar button svg {
    width: 20px;
    height: 20px;
  }
}
.creator-info {
  .row {
    margin: 0;
  }
  .v-card {
    box-shadow: none !important;
  }
  ::v-deep {
    .v-text-field {
      .v-input__slot {
        box-shadow: none !important;
        padding-left: 0 !important;
      }
    }
    .v-input {
      padding: 0px 10px !important;
    }
  }
  .inputIsEdit {
    background-color: #232323;
  }
  .major {
    .row {
      button {
        height: 26px;
        padding: 0 7px;
        font-size: 12px;
        border-radius: 4px;
        min-width: auto;
      }
      &.display {
        button {
          color: rgba(255, 255, 255, 1) !important;
        }
      }
    }
  }
  .tutorial_btn {
    position: absolute;
    right: 0px;
    z-index: 2;
    top: 3px;
    color: #00b6f0;
    font-size: 12px;
    &:before {
      opacity: 0;
    }
  }
}
.close_btn {
  position: absolute;
  top: 8px;
  right: 8px;
}

.no-shadow :deep(.v-input__slot) {
  box-shadow: none !important;
}

.description-wrapper :deep(img) {
  max-width: 100%;
}
</style>